/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import CaseStudiesChildFooter from "./CaseStudiesChildFooter";
import ic_trending_circle from "../../assets/images/pictures/icon/ic_-trending_up_circle-64px.svg";
import ic_paper_circle from "../../assets/images/pictures/icon/ic_paper_circle.svg";
import ic_checkbox_circle from "../../assets/images/pictures/icon/ic_outline-check_box_circle-40px.svg";
import ic_shopping_cart_circle from "../../assets/images/pictures/icon/ic_outline-shopping_cart_circle-40px.svg";
import ic_mailbox_circle from "../../assets/images/pictures/icon/ic_outline-markunread_mailbox_circle-40px.svg";
import ic_confirmation_circle from "../../assets/images/pictures/icon/ic_outline-confirmation_circle-40px.svg";
import ic_receipt_circle from "../../assets/images/pictures/icon/ic_outline-receipt_circle-40px.svg";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import list from "../../assets/images/logos/case/doclist.png";
import cover from "../../assets/images/logos/case/cover-sales.png";
import bite from "../../assets/images/logos/case/bite.png";
import modus from "../../assets/images/logos/case/modus-group.png";
import { useTranslation } from "react-i18next";
import Footer from "../../components/global/Footer";
import NavbarBottom from "../../components/global/NavbarBottom";

const CaseStudiesSalesContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <header className="header--absolute"></header>
      <div className="procurement mt-50">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 header">
              <img
                className="header__ic"
                src={ic_trending_circle}
                alt=""
                data-no-retina=""
              />
              <h2>
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-1.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="col-xs-12">
              <img className="img-responsive" src={list} alt="" />
            </div>
          </div>
          <div className="row stages">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <h2>
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-2.heading"
                )}
              </h2>
            </div>
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 mb-10">
              <p>
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-2.description"
                )}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 col-sm-offset-3 stage-cycle">
              <div className="col-sm-4">
                <img src={ic_paper_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-sales-page.case-studies-sales-page-content.content-2.item-1"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_checkbox_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-sales-page.case-studies-sales-page-content.content-2.item-2"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_shopping_cart_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-sales-page.case-studies-sales-page-content.content-2.item-3"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_mailbox_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-sales-page.case-studies-sales-page-content.content-2.item-4"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_confirmation_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-sales-page.case-studies-sales-page-content.content-2.item-5"
                  )}
                </p>
              </div>
              <div className="col-sm-4">
                <img src={ic_receipt_circle} alt="" data-no-retina="" />
                <p>
                  {t(
                    "case-studies-sales-page.case-studies-sales-page-content.content-2.item-6"
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="row about-pro">
            <div className="col-sm-5">
              <img className="img-responsive" src={cover} alt="" />
            </div>
            <div className="col-sm-7">
              <h2>
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-3.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-3.description-1"
                )}
              </p>
              <p>
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-3.description-2"
                )}
              </p>
              <a
                className="btn-secondary"
                href="javascript:;"
                data-toggle="modal"
                data-target="#download-book"
              >
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-3.button-access"
                )}
              </a>
              <hr />
              <h6>
                {t(
                  "case-studies-sales-page.case-studies-sales-page-content.content-3.description-3"
                )}
              </h6>
              <div className="departments">
                <img
                  className="departments__icon"
                  src={modus}
                  alt="Modus Group"
                />
                <img className="departments__icon" src={bite} alt="BITĖ" />
              </div>
            </div>
          </div>
        </div>
        <CaseStudiesChildFooter />
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesSalesContent;
